import { render, staticRenderFns } from "./legstats.vue?vue&type=template&id=1a1fe7ee&"
import script from "./legstats.vue?vue&type=script&lang=js&"
export * from "./legstats.vue?vue&type=script&lang=js&"
import style0 from "./legstats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports